import { render, staticRenderFns } from "./reissue.vue?vue&type=template&id=9538f5be&scoped=true&"
import script from "./reissue.vue?vue&type=script&lang=ts&"
export * from "./reissue.vue?vue&type=script&lang=ts&"
import style0 from "./reissue.vue?vue&type=style&index=0&id=9538f5be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9538f5be",
  null
  
)

export default component.exports